import dataServices from '@/shared/api/dataServices';
import set from 'lodash/set';
// import i18n from '@/i18n';

import {
  MOTOR_GET_DATA,
  MOTOR_RESET_STATE,
  MOTOR_SEARCH_VEHICLE,
  MOTOR_SET_MODEL,
  MOTOR_SET_MAKE,
  MOTOR_UPDATE_DATA,
  MOTOR_UPDATE_VALUE,
  MOTOR_SET_OFFER_STEP,
  MOTOR_SET_PAYMENT_STEP,
  MOTOR_CALCULATION,
  MOTOR_PACKAGE_SELECTION,
  MOTOR_PACKAGE_CALCULATION,
  MOTOR_QUOTATION,
  MOTOR_SET_PROMO,
  MOTOR_SET_LANGUAGE
} from '../mutation-types';

const initialState = () => ({
  steps: [
    {
      ID: 1,
      DESC: 'VEHICLE',
      SUBSTEPS: [1],
      ACTIVATED: false
    },
    {
      ID: 2,
      DESC: 'DRIVER',
      SUBSTEPS: [2],
      ACTIVATED: false
    },
    {
      ID: 3,
      DESC: 'OFFER',
      SUBSTEPS: [3, 4],
      ACTIVATED: false
    },
    {
      ID: 4,
      DESC: 'PAYMENT',
      SUBSTEPS: [5],
      ACTIVATED: false
    }
  ],
  offer_step: 0,
  payment_step: 1,
  send_via_email: false,
  motor: {}
});

const state = initialState();

const mutations = {
  [MOTOR_GET_DATA](state, data) {
    state.motor = data;
  },
  [MOTOR_RESET_STATE]() {
    Object.assign(state, initialState());
  },
  [MOTOR_SEARCH_VEHICLE](state, data) {
    state.motor.CS_VEHICLE = { ...state.motor.CS_VEHICLE, ...data.CS_VEHICLE };
    data.ET_LOVS.forEach((item) => {
      const index = state.motor.ET_LOVS.findIndex((o) => o.LOV_NAME === item.LOV_NAME);
      if (index >= 0) {
        state.motor.ET_LOVS[index] = { ...item };
      }
    });
  },
  [MOTOR_SET_MODEL](state, model) {
    const index = state.motor.ET_LOVS.findIndex((o) => o.LOV_NAME === model.ET_LOVS[0].LOV_NAME);
    state.motor.ET_LOVS[index] = { ...model.ET_LOVS[0] };
  },
  [MOTOR_SET_MAKE](state, make) {
    const index = state.motor.ET_LOVS.findIndex((o) => o.LOV_NAME === make.ET_LOVS[0].LOV_NAME);
    state.motor.ET_LOVS[index] = { ...make.ET_LOVS[0] };
  },
  [MOTOR_UPDATE_DATA](state, data) {
    state.motor = { ...data };
  },
  [MOTOR_UPDATE_VALUE](state, data) {
    set(state, data.path, data.value);
  },
  [MOTOR_SET_OFFER_STEP](state, step) {
    if (step <= 0) {
      state.offer_step = 0;
    } else {
      state.offer_step = step;
    }
    const stepIndex = state.steps.findIndex((o) => o.SUBSTEPS.includes(step));
    // if (stepIndex >= 0) {
    //   state.steps[stepIndex].ACTIVATED = true;
    // }
    state.steps = [...state.steps.map((o, index) => {
      if (index <= stepIndex) {
        // eslint-disable-next-line no-param-reassign
        o.ACTIVATED = true;
        return o;
      }
      // eslint-disable-next-line no-param-reassign
      o.ACTIVATED = false;
      return o;
    })];
  },
  [MOTOR_SET_PAYMENT_STEP](state, step) {
    if (step <= 0) {
      state.payment_step = 1;
    } else {
      state.payment_step = step;
    }
  },
  [MOTOR_CALCULATION](state, data) {
    state.motor = { ...state.motor, ...data };
    console.log(state.motor);
    // state.motor.CT_PACKAGES = data.CT_PACKAGES;
  },
  [MOTOR_PACKAGE_SELECTION](state, data) {
    state.motor.CT_PACKAGES = state.motor.CT_PACKAGES.map((item) => {
      // eslint-disable-next-line no-param-reassign
      item.ZZSELECTED_IND = false;
      return item;
    });
    const index = state.motor.CT_PACKAGES.findIndex((item) => item.PACKAGE_ID === data.PACKAGE_ID);
    state.motor.CT_PACKAGES[index].ZZSELECTED_IND = true;
    state.motor.CS_POLICY.PRODUCT_ID = state.motor.CT_PACKAGES[index].PRODUCT_ID;
    state.motor.CS_POLICY.PACKAGE_ID = state.motor.CT_PACKAGES[index].PACKAGE_ID;
    state.motor.CT_OFFERS = [state.motor.CT_PACKAGES[index]];
  },
  [MOTOR_PACKAGE_CALCULATION](state, { packageData, data }) {
    state.motor.CT_PACKAGES = state.motor.CT_PACKAGES.map((item) => {
      // eslint-disable-next-line no-param-reassign
      item.ZZSELECTED_IND = false;
      return item;
    });
    const packageIndex = state.motor.CT_PACKAGES.findIndex((item) => item.PACKAGE_ID === packageData.CT_PACKAGES[0].PACKAGE_ID);
    state.motor.CT_PACKAGES[packageIndex].ZZSELECTED_IND = true;
    state.motor.CT_PACKAGES[packageIndex].AMOUNT = packageData.CT_PACKAGES[0].AMOUNT;
    state.motor.CS_POLICY.PRODUCT_ID = state.motor.CT_PACKAGES[packageIndex].PRODUCT_ID;
    state.motor.CS_POLICY.PACKAGE_ID = state.motor.CT_PACKAGES[packageIndex].PACKAGE_ID;
    state.motor.CT_OFFERS = [state.motor.CT_PACKAGES[packageIndex]];
    const coverIndex = state.motor.CT_COVERS.findIndex((item) => item.COVER_ID === data.CT_COVERS[0].COVER_ID && item.PACKAGE_ID === data.CT_COVERS[0].PACKAGE_ID);
    state.motor.CT_COVERS[coverIndex].ZZSELECTED_IND = true;
  },
  [MOTOR_QUOTATION](state, data) {
    state.motor = { ...state.motor, ...data };
  },
  [MOTOR_SET_PROMO](state, data) {
    state.motor = { ...state.motor, ...data };
  },
  [MOTOR_SET_LANGUAGE](state, data) {
    if (!data) return;
    data.ET_LOVS.forEach((item) => {
      const index = state.motor.ET_LOVS.findIndex((o) => o.LOV_NAME === item.LOV_NAME);
      if (index >= 0) {
        state.motor.ET_LOVS[index] = { ...item };
      }
    });
    data.ET_LOVS_DEP.forEach((item) => {
      const index = state.motor.ET_LOVS_DEP.findIndex((o) => o.LOV_NAME === item.LOV_NAME);
      if (index >= 0) {
        state.motor.ET_LOVS_DEP[index] = { ...item };
      }
    });
  },
};

const actions = {
  async getMotorDataAction({ commit }) {
    const data = await dataServices.getMotorData();
    // console.log(data);
    commit(MOTOR_GET_DATA, data);
  },
  motorResetStateAction({ commit }) {
    commit(MOTOR_RESET_STATE);
  },
  async searchVehicleAction({ commit }, data) {
    const vehicle = await dataServices.searvhVehicle(data);
    commit(MOTOR_SEARCH_VEHICLE, vehicle);
  },
  async motorGetModelAction({ commit }, data) {
    const model = await dataServices.motorGetModel(data);
    commit(MOTOR_SET_MODEL, model);
  },
  async motorGetMakeAction({ commit }, data) {
    const make = await dataServices.motorGetManufacturer(data);
    commit(MOTOR_SET_MAKE, make);
  },
  motorUpdateDataAction({ commit }, data) {
    commit(MOTOR_UPDATE_DATA, data);
  },
  motorUpdateValueAction({ commit }, data) {
    commit(MOTOR_UPDATE_VALUE, data);
  },
  setMotorOfferStepAction({ commit }, step) {
    commit(MOTOR_SET_OFFER_STEP, step);
  },
  setMotorPaymentStepAction({ commit }, step) {
    commit(MOTOR_SET_PAYMENT_STEP, step);
  },
  async motorCalculationAction({ commit }, data) {
    // console.log(data);
    const calculationData = await dataServices.motorCalculation(data);
    commit(MOTOR_CALCULATION, calculationData);
  },
  motorSelectPackageAction({ commit }, data) {
    commit(MOTOR_PACKAGE_SELECTION, data);
  },
  async motorPackageCalculation({ commit }, data) {
    const packageData = await dataServices.motorPackageCalculation(data);
    commit(MOTOR_PACKAGE_CALCULATION, { packageData, data });
  },
  async motorQuotationAction({ commit }, data) {
    const quotation = await dataServices.motorQuotation(data);
    commit(MOTOR_QUOTATION, quotation);
  },
  motorPromoAction({ commit }, data) {
    // console.log(commit, data);
    commit(MOTOR_SET_PROMO, data);
  },
  async motorSetLanguage({ commit, state }) {
    const response = await dataServices.languageReset({
      CS_POLICY: state.motor.CS_POLICY, CS_POLICY_HOLDER: state.motor.CS_POLICY_HOLDER, CS_VEHICLE: state.motor.CS_VEHICLE, CS_DRIVERS: state.motor.CS_DRIVERS
    });
    commit(MOTOR_SET_LANGUAGE, response);
  }
};

const getters = {
  getMotorSteps: (state) => state.steps,
  getMotorOfferStep: (state) => state.offer_step,
  getMotorPaymentStep: (state) => state.payment_step,
  getSendEmail: (state) => state.send_via_email
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
